import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { WhatsAppMessage, WhatsAppChatService } from './whatsapp-chat.service';
import 'rxjs/add/operator/filter';

export interface ChatMessage extends WhatsAppMessage { }

export interface ChatNotification {
  unreadCount: number;
  messages: WhatsAppMessage[];
  hasNewMessages: boolean;
}

@Injectable()
export class ChatNotificationService {
  private notificationSubject = new BehaviorSubject<ChatNotification>({
    unreadCount: 0,
    messages: [],
    hasNewMessages: false
  });

  public notification$ = this.notificationSubject.asObservable();
  private currentUser: any;
  private subscription: any;

  constructor(private whatsappService: WhatsAppChatService) {
    // Check if user is already logged in and initialize
    this.currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    if (this.shouldInitialize()) {
      this.initializeNotifications();
    }
  }

  public initializeAfterLogin() {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    if (this.shouldInitialize()) {
      // Clear any existing subscription
      if (this.subscription) {
        this.subscription.unsubscribe();
      }
      this.initializeNotifications();
    }
  }

  public handleLogout() {
    this.currentUser = {};
    this.clearNotifications();
  }

  private shouldInitialize(): boolean {
    // Refresh currentUser from localStorage
    this.currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');

    return this.currentUser.salon_id &&
      this.currentUser.whatsAppEnabled === '1';
  }

  private initializeNotifications() {

    // First, ensure WhatsApp service is polling
    this.whatsappService.startPollingIfAllowed();

    // Then subscribe to messages from WhatsApp service
    this.subscription = this.whatsappService.messages$.subscribe(messages => {
      const unreadMessages = messages.filter(msg => msg.is_read === '0');
      const notification: ChatNotification = {
        unreadCount: unreadMessages.length,
        messages: unreadMessages,
        hasNewMessages: unreadMessages.length > 0
      };
      this.notificationSubject.next(notification);
    });
  }

  markAsRead(messageId: number): Observable<any> {
    return this.whatsappService.markAsRead(messageId);
  }

  startPolling() {
    // Polling is handled by WhatsAppChatService
  }

  stopPolling() {
    // Polling is handled by WhatsAppChatService
  }

  getNotifications(): Observable<ChatNotification> {
    if (!this.shouldInitialize()) {
      return new BehaviorSubject<ChatNotification>({
        unreadCount: 0,
        messages: [],
        hasNewMessages: false
      }).asObservable();
    }
    return this.notification$;
  }

  clearNotifications() {
    this.notificationSubject.next({
      unreadCount: 0,
      messages: [],
      hasNewMessages: false
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/services/chat-notification.service.ts